import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { ApiUsed } from 'components/list/reports/ApiUsed'
import { Context } from 'components/list/reports/Context'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { updatingReport } from 'utils/Reports'

const Edit = ({open, setOpen, selectedRow, rows}) => {
    const { t } = useTranslation()

    const {
        queries,
        params,
        apis,
        loadingUpdate,
        setLoadingUpdate,
    } = useContext(Context)

    const closing = () => {
        setOpen(false)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={() => closing()}
                maxWidth='lg'
                fullWidth
            >
                <DialogTitle>
                    <Typography variant='body3'>{ t('custom_reports.reports.table.dialog.edit_api.title') }</Typography>
                </DialogTitle>

                <DialogContent dividers>
                    <ApiUsed
                        open={open}
                        setOpen={setOpen}
                        selectedRow={selectedRow}
                        rows={rows}
                    />
                </DialogContent>

                <DialogActions>
                    <LoadingButton
                        variant='contained'
                        disableElevation
                        onClick={() => {
                            console.log('queries', queries)
                            console.log('params', params)
                            console.log('apis', apis)
                            updatingReport(
                                selectedRow[0],
                                queries,
                                params,
                                apis,
                                setLoadingUpdate,
                                closing
                            )
                        }}
                        loading={loadingUpdate}
                        disabled={loadingUpdate}
                    >
                        {t('custom_reports.reports.table.dialog.edit_api.buttons.edit')}
                    </LoadingButton>

                    <Button
                        sx={{mr: 2}}
                        variant='contained'
                        disableElevation
                        color='error'
                        onClick={() => closing()}
                    >
                        {t('custom_reports.reports.table.dialog.edit_api.buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export {
    Edit
}
